import { useTranslation } from 'react-i18next';

import type { StaffProfileStoresItem } from '@nucleus-commerce/api-client/admin';
import { Badge } from '@nucleus-commerce/ui/components/badge';

export interface StoreAccessProps {
  /** Empty means every store. */
  storeIds: readonly string[];
  /** The viewer's stores from /me; a store outside them shows as unknown. */
  stores: readonly StaffProfileStoresItem[];
}

export function StoreAccess({ storeIds, stores }: StoreAccessProps) {
  const { t } = useTranslation('team');
  if (storeIds.length === 0) {
    return <span className="text-muted-foreground text-sm">{t('access.all')}</span>;
  }
  return (
    <div className="flex flex-wrap gap-1">
      {storeIds.map((id) => (
        <Badge key={id} variant="secondary" className="max-w-40 truncate font-normal">
          {stores.find((store) => store.id === id)?.name ?? t('access.unknownStore')}
        </Badge>
      ))}
    </div>
  );
}
